import React from "react";
import { useRecoilValue } from "recoil";
import { Box } from "@mui/material";
import { useMyTimeRequestCount } from "my-time/hooks";
import { OcSidebarBadge } from "oc/components/sidebar-badge";
import { ocCustomerLicencesState } from "states";

export const MyTimeMenuBadges = () => {
  const { data } = useMyTimeRequestCount();
  const licences = useRecoilValue(ocCustomerLicencesState);
  if (licences && licences?.myTime === false) return null;

  if (data === 0) return null;

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <OcSidebarBadge value={data} urgent id="myTimeMenuBadge" />
    </Box>
  );
};
